<template>
  <div>
    <eden-page-stats
      class="mt-0"
      :title="'Overview'"
      :loading="loading"
      :stats="stats"
      :show-periods="true"
      :periods="periods"
      :show-custom-period="true"
      @set-period="getScheduleStats"
    />
    <eden-table-actions :title="title" @search="setSearchQuery">
      <template slot="actions">
        <eden-periods
          :default-period="'today'"
          :show-custom-period="true"
          @set-period="getSchedule"
        />
      </template>
    </eden-table-actions>
    <all-orders-view
      :loading="loading"
      :service="'cleaning'"
      :orders="schedule"
    />
  </div>
</template>

<script>
import { cleaningSchedule } from "./Views/mock";
import AllOrdersView from "@/components/Logistics/Schedule/Views/AllOrdersView";

export default {
  name: "ScheduleCleaning",
  components: { AllOrdersView },
  data() {
    return {
      loading: false,
      searchQuery: "",
      period: "today",
      periods: {
        today: "Today",
        tomorrow: "Tomorrow",
        thisweek: "This week",
      },
      schedule: cleaningSchedule(),
    };
  },
  computed: {
    title() {
      return `${this.schedule.length}  Orders`;
    },
    stats() {
      const stats = [
        {
          label: "Cleaning orders",
          figure: 21,
        },
        {
          label: "Cleaners assigned",
          figure: 16,
        },
        {
          label: "Cleaners completed",
          figure: 13,
        },
        {
          label: "Cleaners pending",
          figure: 3,
        },
        {
          label: "Completed orders",
          figure: 15,
        },
        {
          label: "Incomplete orders",
          figure: 6,
        },
      ];

      return this.period !== "today" ? stats.slice(0, 2) : stats;
    },
  },
  methods: {
    setSearchQuery(query) {
      this.searchQuery = query;
    },
    getScheduleStats({ period, from, to }) {
      this.period = period;
      console.log(period, from, to);
    },
    getSchedule({ period, from, to }) {
      console.log(period, from, to);
    },
  },
};
</script>
